module.exports = __webpack_public_path__ + "static/img/course_support_2.7411757.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/course_support_2.png
// module id = Eb91
// module chunks = 1